import styled from "styled-components";
import { IoArrowUpCircleSharp, IoArrowDownCircleSharp } from "react-icons/io5";

export const Content = styled.div`
  width: 100%;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
`;

export const HeaderGrid = styled.div`
  width: 600px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 440px 60px 2fr;
  gap: 16px;
  align-items: center;

  margin-bottom: 24px;

  background-color: #eaefff;
  padding: 8px 12px;
  border-radius: 8px;
`;

export const HeaderItem = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 15.6px;
  color: #3b82f6;
  height: 15.59px;
`;

export const HighlightRow = styled.div`
  width: 600px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 450px auto;
  gap: 20px;

  align-items: start;

  margin-bottom: 16px;
`;
export const HighlightActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

export const IconsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HighlightCard = styled.div`
  background-color: #ffe5e5;
  border: 1px solid #f43636;
  border-radius: 8px;
  padding: 16px;
  height: 81px;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: start;
`;

export const HighlightName = styled.h3`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  color: #f43636;
  margin: 0;

  span {
    font-weight: 400;
    color: #f43636;
  }
`;

export const HighlightSubtitle: any = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #f43636;
  margin: 4px 0 0;
  text-decoration: ${(props: any) =>
    props.textLine ? "line-through" : "none"};
`;

export const PositionNumberHighlight = styled.div`
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background-color: #f43636;
  color: #fff;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  display: flex;
  margin-right: 4px;
  align-items: center;
  justify-content: center;
`;

export const ButtonIniciar = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0 10px;
  min-width: 128.47px;
  height: 31px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const Divider = styled.div`
  height: 4px;
  background-color: #f6b0b0;
  border-radius: 8px;
  margin-top: 32px;
  width: 100%;
`;

/** LISTA CENTRALIZADA */
export const ListContainer = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const Card = styled.div`
  background-color: #ececec;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SquareContainer = styled.div`
  flex: 0.1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Square = styled.div`
  width: 42px;
  height: 46px;
  aspect-ratio: 1;
  background-color: #f18935;
  border-radius: 8px;
`;

export const RightSquareContainer = styled.div`
  flex: 0.1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RightSquare = styled.div`
  width: 42px;
  height: 46px;
  max-width: 120px;
  background-color: #f18935;
  border-radius: 8px;
`;

export const TextSquare = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  //styleName: XXS/Medium;
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #ffffff;
`;

export const CardTitle: any = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  color: ${({ color }) => color || "#646363"};
  max-width: ${(props: any) => props.width || ""};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-decoration: ${(props: any) =>
    props.textLine ? "line-through" : "none"};
`;

export const CardSubtitle: any = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  color: ${({ color }) => color || "#646363"};
  max-width: ${(props: any) => props.width || ""};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-decoration: ${(props: any) =>
    props.textLine ? "line-through" : "none"};
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 16px;
`;

export const Arrows = styled.div`
  display: flex;
  gap: 4px;
`;

export const UpArrow = styled(IoArrowUpCircleSharp)`
  cursor: pointer;
  color: #555;
  font-size: 18px;

  &:hover {
    color: #000;
  }
`;

export const DownArrow = styled(IoArrowDownCircleSharp)`
  cursor: pointer;
  color: #555;
  font-size: 18px;

  &:hover {
    color: #000;
  }
`;

export const PositionNumber = styled.div`
  background-color: #ececec;
  border: 1px solid #d5d5d5;
  color: #a3a3a6;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  width: 42px;
  height: 42px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpaceY = styled.div<{ space: number }>`
  height: ${({ space }) => space}px;
`;
